import { defineStore } from 'pinia';
import { ref } from 'vue';
import Id from "@/roc/grid/Id";
export const useExpansionStore = defineStore('Expansions', () => {
    const expansions = ref({});
    return {
        // state
        expansions,
        // actions
        unlockExpansion(id) {
            delete expansions.value[id];
        },
        setLockedExpansions(expansionList) {
            expansions.value = {
                ...expansionList
            };
        },
        loadExpansionConfiguration(expansionList) {
            expansions.value = {};
            for (let i = 0; i < expansionList.length; i++) {
                expansions.value[Id.generate()] = {
                    ...expansionList[i]
                };
            }
        }
    };
});
